export default "/images/feeding_practices_foods_served_sm.jpg?26542b7ba72ff77b7775648c7dfc0b89";